module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-Regular-9473e20818761a04a975fb5e29f4388b.woff2";